import MediaLibraryPage from "@/pages/mediaLibrary/MediaLibraryPage";
import {selectedCompanyIdAtom} from "@/store/jotaiAtoms";
import {useMediaLibraryStore} from "@/store/mediaLibrary";
import {createFileRoute} from "@tanstack/react-router";
import {getDefaultStore} from "jotai";

export const Route = createFileRoute("/_authenticated/_agency/agency/$agencyId/media-library")({
  component: MediaLibraryPage,
  params: {
    parse: raw => ({agencyId: +raw.agencyId}),
    stringify: params => ({agencyId: params.agencyId?.toString()}),
  },
  loader: ({params}) => {
    getDefaultStore().set(selectedCompanyIdAtom, null);
    useMediaLibraryStore.getState().setRouteIds({agencyId: params.agencyId});
  },
});
